<template>
  <div class="services">
    <h2 class="ui header" v-if="header">
      <i class="window maximize grey icon" />
      <sui-header-content>{{header}}</sui-header-content>
    </h2>
    <transition-group class="ui cards entities" name="card">
      <sui-card class="card-item" key="new">
        <sui-button-group class="fluid content" basic vertical size="huge">
          <router-link class="ui left labeled icon button" :class="{disabled: !actions.serviceCreate}" :to="`/new-service?project=${project.name}`" data-goal="SERVICE_CARDS_CREATE">
            <i class="blue window maximize icon" />
            New service
          </router-link>
          <router-link class="ui left labeled icon button" :class="{disabled: !actions.serviceCreate}" :to="project ? `/new-stack?project=${project.name}` : '/new-stack'" data-goal="SERVICE_CARDS_IMPORT">
            <i class="green briefcase icon" />
            New stack
          </router-link>
        </sui-button-group>
      </sui-card>
      <ServiceCard class="card-item" :service="service" v-for="service in services" :key="service.id"/>
    </transition-group>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ServiceCard from './Service'

  export default {
    name: 'ServiceCards',
    components: {
      ServiceCard,
    },
    props: {
      header: {
        type: String,
        required: false,
        default: 'Services',
      },
      services: {
        type: Array,
        required: true,
      },
    },
    computed: {
      ...mapGetters(['access', 'actionsById', 'projects']),
      actions() {
        return this.project ? this.actionsById[this.project.id] : {}
      },
      project() {
        const name = decodeURIComponent(this.$route.params.project)
        const project = this.projects.find(entity => entity.id === name || entity.name === name)
        return project
      },
    },
    methods: {
      openServiceCreator() {
        this.$modals.createService.open()
      },
    }
  }
</script>

<style scoped>
  .ui.card > .content { display: flex; flex-grow: 1!important; padding: 0!important; }
  .ui.buttons { margin: 0!important; width: auto!important; }
  .ui.buttons .ui.button { flex: 1; min-height: 3.8em; justify-content: flex-start!important; align-items: center!important; padding-left: 4em!important; white-space: nowrap; }
  .ui.buttons .ui.button:hover { background-color: #eee; box-shadow: none!important; }
  .ui.buttons .ui.button >>> .icon { display: flex; align-items: center; font-size: 1.3em; }
</style>
